import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { lakeOswegoConfig } from "./data";

export default function LakeOswegoPage() {
  return <OregonCityPageTemplate config={lakeOswegoConfig} />;
}